import React from 'react';
import DatoAsset from '../asset';
const MediaItem = ({ item, alt, className, style, objectFit, objectPosition, autoPlay, muted, isStatic, onPlayStateChange, loading, }) => {
    const media = (Array.isArray(item) ? item[0] : item) || null;
    if (!media)
        return null;
    return (React.createElement(DatoAsset, { alt: alt, objectFit: objectFit, objectPosition: objectPosition, className: className, style: style, asset: media.optimizedImage || media.image || media.video || media.externalVideo, autoPlay: autoPlay || media.isInline, muted: muted || media.isInline, thumbnail: media.thumbnail, isStatic: isStatic, onPlayStateChange: onPlayStateChange, loading: loading }));
};
export default MediaItem;
//# sourceMappingURL=index.js.map